import React from "react";
import Router from "./Router";
import { createTheme, ThemeProvider as MuiThemeProvider } from "@mui/material";
import {
  InfoSnackbarProvider,
} from "./lib/bandung/contexts/InfoSnackbarContext";

import { ThemeProvider as CustomProvider, useTheme } from "./components/Theme";



// const themeOptions = {
//   palette: {
//     mode: "light",
//     primary: {
//       main: "#1e3faf",
//     },
//   },
//   typography: {
//     fontFamily: "Inter",
//   },
// };

const getThemeOptions = (mode) => ({
  palette: {
    mode: mode,
    primary: {
      main: "#1e3faf",
    },
  },
  typography: {
    fontFamily: "Inter",
  },
});




// const App = () => {
//   const { darkMode } = useTheme(); 

//   const theme = createTheme(getThemeOptions(darkMode ? 'dark' : 'light'));


// //  const theme = createTheme(themeOptions);
//   return (
//       <ThemeProvider theme={theme}>
//       <CustomProvider>
//       <InfoSnackbarProvider>
//         <Router/>
//       </InfoSnackbarProvider>
//       </CustomProvider>
//     </ThemeProvider>
//   );
// };

const App = () => {
  return (
    <CustomProvider>
      <ChildComponent />
    </CustomProvider>
  );
};

const ChildComponent = () => {
  const { darkMode } = useTheme();

  const theme = createTheme({
    palette: {
      mode: darkMode ? 'dark' : 'light',
    },
    typography: {
      fontFamily: "Inter",
    },
  });

  return (
    <MuiThemeProvider theme={theme}>
      <InfoSnackbarProvider>
        <Router />
      </InfoSnackbarProvider>
    </MuiThemeProvider>
  );
};





export default App;






